<mat-card style="background-color: #f8f8ff; width: 100%; height: auto">
    <div id="menus" style="min-height: 95vh; height: auto">
        <div class="card-body-content" style="width: 99%; min-height: 90%; max-height: 99%; height: 90%">
            <br />
            <mat-card style="height: 99%">
                <mat-card-actions class="alinearBotonSalirAdministrador">
                    <a [routerLink]="[]" class="salirAdministrador" (click)="salirAdministrador()">Salir del
                        administrador</a>
                </mat-card-actions>
                <div class="header">
                    <app-navegacion></app-navegacion>
                    <h2>Editando asistente
                        <img src="assets/images/basecomponents-images/vectors55931032.svg" width="15.166625976562px"
                            height="8.2947998046875px" class="icon-navegacion css-Vector_attach_file vector_attachfile">
                        Administrador menú
                    </h2>
                </div>
                <div class="nuevo-asistente-container">

                    <div class="form-group">
                        <app-campo-default-admin descripcion_etiqueta="Identificador de menú"
                            placeholder_input="Este campo es obligatorio" [(ngModel)]="idMenu">
                        </app-campo-default-admin>
                    </div>

                    <div class="form-group">
                        <app-campo-default-admin descripcion_etiqueta="Nombre"
                            placeholder_input="Este campo es obligatorio" [(ngModel)]="descripcion">
                        </app-campo-default-admin>
                    </div>

                    <div class="form-group">
                        <app-campo-default-admin descripcion_etiqueta="Descripción"
                            placeholder_input="Este campo es obligatorio" [(ngModel)]="texto">
                        </app-campo-default-admin>
                    </div>

                    <div class="form-group">
                        <app-campo-default-admin id="areaFuncional" name="areaFuncional"
                            descripcion_etiqueta="Área Funcional" placeholder_input="Este campo es obligatorio"
                            [(ngModel)]="gafuAreaFuncional">
                        </app-campo-default-admin>
                    </div>

                    <div class="form-group" style="text-align: center;">
                        <mat-radio-group name="opciones" [(ngModel)]="habilitado">
                            <mat-radio-button name="opciones" [value]="true" style="margin: 10px">
                                Habilitado
                            </mat-radio-button>
                            <mat-radio-button name="opciones" [value]="false" style="margin: 10px">
                                Deshabilitado
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>

                    <app-mensaje-error *ngIf="error" [mensaje_error]="error"></app-mensaje-error>
                    <div class="fin">
                        <app-boton-primario [disabled]="loading" [boton_texto]="loading ? 'Guardando' : 'Guardar'"
                            (boton_funcion)="applyOperation()"></app-boton-primario>
                    </div>
                </div>
            </mat-card>
        </div>
    </div>
</mat-card>